import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CustomSelectDropdown } from "./custom.select";
import { selectStyle } from "../../../shared/fixtures/select_style";
import telephone_codes from "../../../shared/fixtures/telephone_codes";
import { P } from "../Texts";

export const PhoneExt = (props) => {
  const formCtx = useFormContext();
  const {
    formState: { errors: formStateErrors },
  } = formCtx;
  return (
    <>
      <label htmlFor="opCategory">
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          Extension
          <span
            className=""
            style={{
              color: "#E62250",
            }}
          >
            *
          </span>
        </P>
      </label>

      <Controller
        control={props.control}
        {...props}
        defaultValue=""
        rules={props.validation}
        render={({ field }) => (
          <CustomSelectDropdown
            autoComplete="true"
            styles={selectStyle}
            {...field}
            className="w-full"
            placeholder="--Select an extension--"
            options={telephone_codes}
          />
        )}
      />

      {formStateErrors[props.name] && (
        <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm">
          {/* Select an extension" */}
        </P>
      )}
    </>
  );
};
